/* eslint no-unused-vars: "off" */
import React, { Component } from 'react';
import PageBreak from './PageBreak';

class ReportPage extends Component {
    render() {  
        return [            
            <div key="page" className={"report-page " + this.props.className + ' ' + (this.props.longSubtitle ? 'long-subtitle' : '') + ' ' + (this.props.portrait ? 'portrait-page' : 'landscape-page')}>
                <section className="report-header">
                    <div className="report-bar"></div>
                    {this.props.title ? <h1>{this.props.title}</h1> : null }
                    {this.props.title2 ? <h1>{this.props.title2}</h1> : null }
                    {this.props.subtitle ? <h2 dangerouslySetInnerHTML={{__html: this.props.subtitle }} /> : null }
                </section>
                <section className="report-content">
                    {this.props.children}
                </section>
                <section className={this.props.portrait ? "report-footer" : "report-footer report-mini"}>
                    For Institutional and Plan Sponsor Use Only – Not for Public Use
                    <span>{this.props.pageNumber}</span>
                </section>
            </div>,
            this.props.addBreak ? <PageBreak key="break" /> : null
        ];
    }
}

export default ReportPage;
